import _ from 'lodash'
import api from '../../api'

export default {
  state: () => ({
    me: null,
    joinedGame: null,
    openArchive: true,
  }),
  getters: {
    me: state => state.me,
    openArchive: state => state.openArchive,
    joinedGame: state => _.get(state.me, 'game'),
    myTeam: state => _.get(state.me, 'team', {}),
    amIAdmin: (state, getters) => _.get(state.me, 'role') === 'ADMIN',
    amIOwner: (state, getters) => _.get(state.me, 'role') === 'GAME_OWNER'
  },
  actions: {
    async fetchMe({ commit, getters }) {
      if (localStorage.getItem('token')) {
        try {
          console.log("getter", getters.openArchive);
          var test = false;
            if(getters.openArchive && test){//Tady archivované
              const result = await api.userAccount.meForArchived(360)
              await commit('SET_ME', result.data)
            }else{
              const { data } = await api.userAccount.me(false)
              await commit('SET_ME', data)
            }
          return true
        } catch (e) {
          localStorage.removeItem('token')
        }
      }

      return false
    },
    clearMe({ commit }) {
      commit('SET_ME', null)
    },
    async register({ commit }, payload) {
      await api.userAccount.register(payload);
    },
    async verifyRegistration({ commit }, token) {
      await api.userAccount.verifyRegistration(token)
    },
    async forgotPassword({ commit }, form) {
      await api.userAccount.forgotPassword(form)
    },
    async changePassword({ commit }, payload) {
      await api.userAccount.changePassword(payload)
    },
    async changePasswordReset({ commit }, payload) {
      await api.userAccount.changePasswordReset(payload)
    },
    async leaveGame({ dispatch }) {
      dispatch('toggleLoader', true)
      try {
        await api.userAccount.leaveGame()
        dispatch('toggleLoader', false)
        return true
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }
      dispatch('toggleLoader', false)
      return false
    },
  },
  mutations: {
    SET_ME(state, data) {
      state.me = data
    },
    SET_MY_GAME(state, game) {
      state.me = {
        ...state.me,
        game,
      }
    }
  },
}
